import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=56426e4e&scoped=true"
import script from "./couponDetail.vue?vue&type=script&lang=js"
export * from "./couponDetail.vue?vue&type=script&lang=js"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=56426e4e&prod&lang=scss"
import style1 from "./couponDetail.vue?vue&type=style&index=1&id=56426e4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56426e4e",
  null
  
)

export default component.exports